import { isTestEnv } from "constants/environment";

export const baseURL = isTestEnv
	? new URL("", globalThis.location.origin).href
	: `${import.meta.env.VITE_APP_BASEURL}/`;

export const getOrdersInitial = "api/v2/orders";

export const salesforceBaseURL = import.meta.env.VITE_APP_SALESFORCE_DASHBOARD_URL ?? "";
export const billtrustBaseURL = import.meta.env.VITE_APP_BILLTRUST_URL ?? "";
